module.exports = __webpack_public_path__ + "static/media/hubble_welcome.75c6e460.png";